import { BrowserAgent } from "@newrelic/browser-agent/loaders/browser-agent";
if (process.env.REACT_APP_ENV_STATE === "APP-PROD") {
  const options = {
    init: {
      distributed_tracing: { enabled: true },
      privacy: { cookies_enabled: true },
      ajax: { deny_list: ["bam.nr-data.net"] },
    },
    info: {
      beacon: "bam.nr-data.net",
      errorBeacon: "bam.nr-data.net",
      licenseKey: "NRJS-9464a33836375ef3670",
      applicationID: "594616590",
      sa: 1,
    },
    loader_config: {
      accountID: "3937520",
      trustKey: "3733975",
      agentID: "594616590",
      licenseKey: "NRJS-9464a33836375ef3670",
      applicationID: "594616590",
    },
  };
  new BrowserAgent(options);
}
